module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin-ext20.c846289.woff2";